import React, { useEffect, useRef, useState } from "react";
import Plandetail from "./plandetail";
import { useDispatch, useSelector } from "react-redux";
import { getPackageDetails, setCity } from "../../Redux/Actions";
import { GET_PACKAGE_DETAILS_RESET } from "../../Redux/Constants";
import { Scroll } from "../Scroll function/scroll";
import ErrorPage from "../../Pages/ErrorPage";
import { useHistory } from "react-router-dom";
import TopNav from "../TopNav/TopNav";
import { Link } from "react-router-dom";
// import Header from "../Header/Header";
import NewHeader from "../NewHeader/NewHeader";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import Footer from "../Footer/Footer";
import stars from "../../Assets/newAsset/stars.svg";
import { Onecomponent } from "../../Pages/Career";
import watch from "../../Assets/newAsset/lpassets/Watch.webp";
import fasting from "../../Assets/newAsset/lpassets/fasting.webp";
import folder from "../../Assets/newAsset/lpassets/folder.webp";

import Featured from "../../Pages/homePage/Components/Featured";
import SubFooter from "../SubFooter/SubFooter";
import { FaCheck } from "react-icons/fa";

import MObileBG from "../../Assets/newAsset/imaging/sam.webp";
import "./PlanDetailsPage.css";
import Content from "../../Pages/homePage/Components/Content";
import Loader from "../Loader/Loader.js";
import Apointment from "../../Pages/homePage/Components/Apointment";
import step1 from "../../Assets/newAsset/lpassets/newAssets/step1.webp";
import step2 from "../../Assets/newAsset/lpassets/newAssets/step2.webp";
import step3 from "../../Assets/newAsset/lpassets/newAssets/step3.webp";
import step4 from "../../Assets/newAsset/lpassets/newAssets/step4.webp";
import step5 from "../../Assets/newAsset/lpassets/newAssets/step5.webp";

import Meta from "../Meta";
import TestCr from "../../Pages/homePage/TestCr";
import LpForm from "../../Pages/packageDetailsPage/LpForm";
import WhyChooseUslogo1 from "../../Assets/newAsset/lpassets/newAssets/whyCus1.webp";
import WhyChooseUslogo2 from "../../Assets/newAsset/lpassets/newAssets/whyCus2.webp";
import WhyChooseUslogo3 from "../../Assets/newAsset/lpassets/newAssets/whyCus3.webp";
import WhyChooseUslogo4 from "../../Assets/newAsset/lpassets/newAssets/whyCus4.webp";

import "./plandetail.css";
//IMPORTING BOOK NOW BAR FROM JSX
import BookNow from "./BookNow";
import Prefix from "../../config/ApiPrefix";
import Axios from "../../config/Axios";
import "../../Pages/homePage/Components/Content.css";
import logo from "../../Assets/newAsset/lpassets/newAssets/mainLogo.webp";
import { json } from "express";

//content array
const content = [
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diamnonumy eirmod tempor invidunt ut labore et dolore magna aliquyamerat, sed diam voluptua. At vero eos et accusam et justo duo doloreset ea rebum. Stet clita kasd gubergren, no sea takimata sanctus estLorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetursadipscing elitr, sed diam nonumy eirmod tempor invidunt ut laboreet dolore magna aliquyam erat, sed diam voluptua. At vero eos etaccusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,no sea takimata sanctus est Lorem ipsum dolor sit amet.",
];
const stepsData = [
  {
    id: 1,
    img: step1,
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img: step2,
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img: step3,
    desc: "Stored Safely",
  },
  {
    id: 4,
    img: step4,
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img: step5,
    desc: "No Contact Delivery",
  },
];
//FAQ's Data//

const FAQ = [
  {
    id: 1,
    title: "Who should get tested for COVID-19 test? ",
    desc:
      "If someone is having symptoms of an infected respiratory tract, including a persistent cough, sore throat, shortness of breath and fever, that would definitely be a clear sign to go in and get your COVID-19 test done. Also, it is important to get your COVID-19 test done if you think you have come in contact with a confirmed case of a coronavirus patient. .",
  },
  {
    id: 2,
    title: "What are the common symptoms of COVID-19 infection?",
    desc:
      "The most common symptoms of coronavirus disease are dry cough, fatigue, body ache and fever. Some patients may experience more severe forms of the disease, like pneumonia. The best way to confirm if you have caught the virus producing COVID-19 disease is with a COVID-19 laboratory test.",
  },
  {
    id: 3,
    title:
      "Is it important to get my family members tested for COVID-19 if the doctor has prescribed for my RT-PCR test?",
    desc:
      "It is important and safe to get your COVID-19 test done if you have come in close contact with an infected person even if the person is your family member. In the meantime, you and your family members should take necessary precautions such as wearing a mask, proper sanitization, washing your hands for at least 20 seconds and following all safety and hygiene measures.",
  },
  {
    id: 4,
    title: "How to book covid-19 test?",
    desc:
      "Booking a COVID-19 test is easy. You need to visit our website redcliffelabs.com and fill in your details. Our customer service will contact you for home sample collection. To book your COVID-19 test, contact us at 898 898 8787.",
  },
  {
    id: 5,
    title:
      "After booking COVID-19 test at Redcliffe Labs, when will I visit the centre for the test?",
    desc:
      "We understand the importance of lives and the intricacies of this pandemic situation. We thus recommend patients to get their tests done safely at their home. We are providing our patients with the sample home collection service by our expert Phlebotomists. For home collection, you can book your appointment for COVID-19 test at http://redcliffelabs.com/ or by calling us at 898 898 8787.",
  },
  {
    id: 6,
    title: "how can i know if i had covid-19 in past?",
    desc:
      "Whether someone has had covid infection in the past, we at Redcliffe Labs provide our patients with Covid Antibody Test. These tests are usually done via blood samples. Covid Antibody tests are not done to detect covid but it is done to detect whether or not you have had covid infection in the past.",
  },
  {
    id: 7,
    title: "Is it safe to get my test done at home?",
    desc:
      "At Redcliffe Labs, we have a proficient team of Phlebotomists who are trained to follow all safety measures needed for COVID–19 home sample collection. To ensure safety, our Phlebotomists wear Disposable (single use) Personal Protective Equipment (PPE) consisting of gloves, N95 mask, goggles, face shield, hair cover and shoe cover. Once the sample is collected, they dispose of the PPE kit worn during sample collection.",
  },
  {
    id: 8,
    title: "How long does it take to get COVID-19 test results?",
    desc:
      "It usually takes 24-48 hours to get the COVID-19 test report from the time of sample collection.",
  },
  {
    id: 9,
    title: "What is the current testing method used at Redcliffe Labs?",
    desc:
      "At present, RT-PCR test is recommended to detect the presence of COVID-19 virus. COVID Antibody tests are also being done at our labs to ascertain if someone has had coronavirus in the past.",
  },
  {
    id: 10,
    title: "What if I am tested positive for COVID?",
    desc:
      "If you test positive, try to isolate yourself to prevent others from getting sick. Get in touch with your doctor for further medical assistance. If you test negative, you probably were not infected at the time of sample collection.",
  },
];

//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const related_packages = [
  {
    id: 11,
    slug: "smart-plus-full-body-checkup",
    name: "Smart Plus Full Body Checkup",
    parameter: 83,
    description:
      "Thyroid  (3 Tests), CBC (24 Tests), LFT  (12 Tests), KFT  (10 Tests), LIPID  (9 Tests), Blood Sugar Fasting, Urine Routine & Microscopy  (21 Tests), HbA1c  (2 Tests), Vitamin B12",
    details:
      '<div className="firstList">\r\n<h2>Complete Hemogram <span className="totaltests">(24 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Absolute Basophils Count, Blood</li>\r\n<li>Absolute Eosinophil Count, Blood</li>\r\n<li>Absolute Lymphocyte Count, Blood</li>\r\n<li>Absolute Monocyte Count, Blood</li>\r\n<li>Absolute Neutrophil Count, Blood</li>\r\n<li>ESR Automated</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Hemoglobin Hb</li>\r\n<li>MCH</li>\r\n<li>MCHC</li>\r\n<li>MCV</li>\r\n<li>MPV Mean Platelet Volume</li>\r\n<li>PCV Haematocrit</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>PCV Haematocrit</li>\r\n<li>PDW Platelet Distribution Width</li>\r\n<li>Platelet Count Thrombocyte count</li>\r\n<li>WBC-Total Counts Leucocytes</li>\r\n<li>RDW (Red Cell Distribution Width)</li>\r\n<li>Neutrophils</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Eosinophils</li>\r\n<li>Lymphocytes</li>\r\n<li>Monocytes</li>\r\n<li>RDW-CV</li>\r\n<li>MENTZER INDEX9MCV/RCC</li>\r\n<li>PCT</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Liver Function Tests <span className="totaltests">(12 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Albumin, Serum</li>\r\n<li>Alkaline Phosphatase, Serum</li>\r\n<li>Bilirubin Direct, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Bilirubin Total, Serum</li>\r\n<li>GGTP (Gamma GT)</li>\r\n<li>SGPT/ALT</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>A/G Ratio</li>\r\n<li>Proteins, Serum</li>\r\n<li>SGOT/AST</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>                                                                               \r\n<li>Bilirubin- Indirect, serum</li>\r\n<li>Globulin</li>\r\n<li>SGOT/SGPT Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Kidney Function Tests <span className="totaltests">(10 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Blood Urea</li>\r\n<li>Creatinine</li>\r\n<li>Uric Acid</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>BUN</li>\r\n<li>BUN/Creatinine Ratio</li>\r\n<li>Chloride</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Calcium</li>\r\n<li>Phosphorus</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Sodium</li>\r\n<li>potassium</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Lipid Profile Tests <span className="totaltests">(9 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Cholesterol-Total, Serum</li>\r\n<li>HDL Cholesterol Direct</li>\r\n<li>LDL Cholesterol -Direct</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Triglycerides, Serum</li>\r\n<li>Non - HDL Cholesterol, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>VLDL</li>\r\n<li>LDL/HDL RATIO</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>CHOL/HDL RATIO</li>\r\n<li>HDL / LDL Cholesterol Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n\r\n\r\n<div className="firstList">\r\n<h2>Blood Sugar Fasting <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>HbA1c <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Thyroid Tests <span className="totaltests">(3 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>T3, Total Tri Iodothyronine</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>T4, Total Thyroxine</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>TSH Ultra - sensitive</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Urine Routine & Microscopy<span className="totaltests">(21 Tests)</span></h2>\r\n<div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>pH Urine</li>\r\n<li>Amorphous Deposits</li>\r\n<li>Specific gravity</li>\r\n<li>Urobilinogen</li>\r\n<li>Leucocyte Esterase</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Transparency</li>\r\n<li>Albumin</li>\r\n<li>Sugar</li>\r\n<li>Blood</li>\r\n<li>Urine ketones</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Colour</li>\r\n<li>Red blood cells</li>\r\n<li>Pus cells (Leukocytes)</li>\r\n<li>Nitrate</li>\r\n<li>Deposit</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Epithelial cells</li>\r\n<li>Crystals</li>\r\n<li>Cast</li>\r\n<li>Bacteria</li>\r\n<li>Volume</li>\r\n<li>Yeast Cells</li>',
    faq: "",
    recommended_gender: null,
    recommended_age: "15-55",
    is_premium: false,
    package_city_prices: null,
    discount: 60.02,
    package_price: 2499,
    offer_price: 999,
    is_addon: false,
    meta_title:
      "Full Body Checkup in Delhi | Tests Starting @ Rs 699 - Redcliffe Labs",
    meta_description:
      "Full Body Checkup in Delhi - Redcliffe Labs offers several tests for whole body checkup in Delhi including the Liver function test (LFT), Lipid profile test (LPT), Kidney function test (KFT), etc.",
    is_active: true,
    code: "pl12",
    og_tag:
      '{ "title" :"Smart Plus Full Body Checkup in Delhi - Redcliffe Labs", \r\n"site" : "Redcliffe Labs", \r\n"url" : "https://redcliffelabs.com/smart-plus-full-body-checkup-delhi" , \r\n"description" :"Looking for a body check up that help you to live a healthy life? Redcliffe Labs comes with smart plus full body checkup that cover 76 Tests." , \r\n"type" : "Diagnostic Centre" , \r\n"image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg" ,\r\n "robots": "noindex"}',
    twitter_card:
      '{"card" : "summary" , "site" : "Redcliffe Labs" , "title" : "content=Smart Plus Full Body Checkup in Delhi - Redcliffe Labs", "description" : "Looking for a body check up that help you to live a healthy life? Redcliffe Labs comes with smart plus full body checkup that cover 76 Tests.", "image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg" }',
    addon_price: null,
    display_name: "Noida",
    specimen_instructions: null,
    package_center_prices: null,
  },
  {
    id: 8,
    slug: "advance-full-body-checkup",
    name: "Advance Full Body Checkup",
    parameter: 88,
    description:
      "Thyroid  (3 Tests), HbA1c  (2 Tests), CBC (24 Tests), LFT  (12 Tests), KFT (10 Tests), LIPID  (9 Tests), Blood Sugar Fasting, Urine Routine & Microscopy (21 Tests), Vitamin B12 , Vitamin D Total-25 Hydroxy, Iron studies (4 Tests)",
    details:
      '<div className="firstList">\r\n<h2>Complete Hemogram <span className="totaltests">(24 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Absolute Basophils Count, Blood</li>\r\n<li>Absolute Eosinophil Count, Blood</li>\r\n<li>Absolute Lymphocyte Count, Blood</li>\r\n<li>Absolute Monocyte Count, Blood</li>\r\n<li>Absolute Neutrophil Count, Blood</li>\r\n<li>ESR Automated</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Hemoglobin Hb</li>\r\n<li>MCH</li>\r\n<li>MCHC</li>\r\n<li>MCV</li>\r\n<li>MPV Mean Platelet Volume</li>\r\n<li>PCV Haematocrit</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>PDW Platelet Distribution Width</li>\r\n<li>Platelet Count Thrombocyte count</li>\r\n<li>WBC-Total Counts Leucocytes</li>\r\n<li>RDW (Red Cell Distribution Width)</li>\r\n<li>Neutrophils</li>\r\n<li>Basophils</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Eosinophils</li>\r\n<li>Lymphocytes</li>\r\n<li>Monocytes</li>\r\n<li>RDW-CV</li>\r\n<li>MENTZER INDEX9MCV/RCC</li>\r\n<li>PCT</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Liver Function Tests <span className="totaltests">(12 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Albumin, Serum</li>\r\n<li>Alkaline Phosphatase, Serum</li>\r\n<li>Bilirubin Direct, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Bilirubin Total, Serum</li>\r\n<li>GGTP (Gamma GT)</li>\r\n<li>SGPT/ALT</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>A/G Ratio</li>\r\n<li>Proteins, Serum</li>\r\n<li>SGOT/AST</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Bilirubin- Indirect, serum</li>\r\n<li>Globulin</li>\r\n<li>SGOT/SGPT Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Kidney Function Tests <span className="totaltests">(10 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Blood Urea</li>\r\n<li>Creatinine</li>\r\n<li>Uric Acid</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>BUN</li>\r\n<li>BUN/Creatinine Ratio</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Calcium</li>\r\n<li>Phosphorus</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Sodium</li>\r\n<li>Potassium</li>\r\n<li>Chlioride</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Lipid Profile Tests <span className="totaltests">(9 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Cholesterol-Total, Serum</li>\r\n<li>HDL Cholesterol Direct</li>\r\n<li>LDL Cholesterol -Direct</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Triglycerides, Serum</li>\r\n<li>Non - HDL Cholesterol, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>VLDL</li>\r\n<li>LDL/HDL RATIO</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>CHOL/HDL RATIO</li>\r\n<li>HDL / LDL Cholesterol Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Thyroid Tests <span className="totaltests">(3 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>T3, Total Tri Iodothyronine</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>T4, Total Thyroxine</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>TSH Ultra - sensitive</li>\r\n\r\n</ul>\r\n</div>\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>HbA1c <span className="totaltests">(2 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Glycated Hemoglobin</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Average blood glucose</li>\r\n\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n\r\n<div className="firstList">\r\n<h2>Blood Sugar Fasting <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Vitamin B12 <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Vitamin D Total-25 Hydroxy <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Iron Studies <span className="totaltests">(4 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Iron, Serum</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Uibc</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>TIBC</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Transferrin Saturation</li>\r\n\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n\r\n<div className="firstList">\r\n<h2>Urine Routine & Microscopy<span className="totaltests">(21 Tests)</span></h2>\r\n<div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>pH Urine</li>\r\n<li>Specific gravity</li>\r\n<li>Bacteria</li>\r\n<li>Urobilinogen</li>\r\n<li>Volume</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Transparency</li>\r\n<li>Albumin</li>\r\n<li>Sugar</li>\r\n<li>Blood</li>\r\n<li>Deposit</li>\r\n<li>Amorphous Deposits</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Colour</li>\r\n<li>Red blood cells</li>\r\n<li>Pus cells (Leukocytes)</li>\r\n<li>Nitrate</li>\r\n<li>Urine ketones</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Epithelial cells</li>\r\n<li>Crystals</li>\r\n<li>Cast</li>\r\n<li>Leucocyte Esterase</li>\r\n<li>Yeast Cells</li>',
    faq: "",
    recommended_gender: "male,female",
    recommended_age: "15-55",
    is_premium: false,
    package_city_prices: null,
    discount: 65.13,
    package_price: 4299,
    offer_price: 1349,
    is_addon: false,
    meta_title: "Advance Full Body Checkup in Delhi - Redcliffe Labs",
    meta_description:
      "Redcliffe Life Diagnostic serves you advance full body checkup which includes 81 test and sample collection by skilled & trained phlebotomist from your home.",
    is_active: true,
    code: "dfdf",
    og_tag:
      '{ "title" :"Advance Full Body Checkup in Delhi - Redcliffe Labs", "site" : "Redcliffe Labs", "url" : "https://redcliffelabs.com/maternal-marker-double-delhi", "description" :"Redcliffe Life Diagnostic serves you advance full body checkup which includes 81 test and sample collection by skilled & trained phlebotomist from your home." , "image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg","robots":"noindex"}',
    twitter_card:
      '{"card" : "summary" , "site" : "Redcliffe Labs" , "title" :"Advance Full Body Checkup in Delhi - Redcliffe Labs", "description" :"Redcliffe Life Diagnostic serves you advance full body checkup which includes 81 test and sample collection by skilled & trained phlebotomist from your home.", "image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg" }',
    addon_price: null,
    display_name: "Noida",
    specimen_instructions: null,
    package_center_prices: null,
  },
  {
    id: 7,
    slug: "advance-plus-full-body-checkup",
    name: "Advance Plus Full Body Checkup",
    parameter: 92,
    description:
      "Thyroid  (3 Tests) , HbA1c  (2 Tests), CBC (24 Tests), LFT  (12 Tests), KFT (10 Tests), LIPID  (9 Tests), Blood Sugar Fasting, Urine Routine & Microscopy (21 Tests), Vitamin B12 , Vitamin D Total-25 Hydroxy, Iron studies (4 Tests), CRP (C Reactive Protein) Quantitative, RA Test Rheumatoid Arthritis Factor, HsCRP High Sensitivity CRP, IgE Total (Allergy)",
    details:
      '<div className="firstList">\r\n<h2>Complete Hemogram <span className="totaltests">(24 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Absolute Basophils Count, Blood</li>\r\n<li>Absolute Eosinophil Count, Blood</li>\r\n<li>Absolute Lymphocyte Count, Blood</li>\r\n<li>Absolute Monocyte Count, Blood</li>\r\n<li>Absolute Neutrophil Count, Blood</li>\r\n<li>ESR Automated</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Hemoglobin Hb</li>\r\n<li>MCH</li>\r\n<li>MCHC</li>\r\n<li>MCV</li>\r\n<li>MPV Mean Platelet Volume</li>\r\n<li>PCV Haematocrit</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>PDW Platelet Distribution Width</li>\r\n<li>Platelet Count Thrombocyte count</li>\r\n<li>WBC-Total Counts Leucocytes</li>\r\n<li>RDW (Red Cell Distribution Width)</li>\r\n<li>Neutrophils</li>\r\n<li>Basophils</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Eosinophils</li>\r\n<li>Lymphocytes</li>\r\n<li>Monocytes</li>\r\n<li>RDW-CV</li>\r\n<li>MENTZER INDEX9MCV/RCC</li>\r\n<li>PCT</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Liver Function Tests <span className="totaltests">(12 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Albumin, Serum</li>\r\n<li>Alkaline Phosphatase, Serum</li>\r\n<li>Bilirubin Direct, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Bilirubin Total, Serum</li>\r\n<li>GGTP (Gamma GT)</li>\r\n<li>SGPT/ALT</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>A/G Ratio</li>\r\n<li>Proteins, Serum</li>\r\n<li>SGOT/AST</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Bilirubin- Indirect, serum</li>\r\n<li>Globulin</li>\r\n<li>SGOT/SGPT Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Kidney Function Tests <span className="totaltests">(10 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Blood Urea</li>\r\n<li>Creatinine</li>\r\n<li>Uric Acid</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>BUN</li>\r\n<li>BUN/Creatinine Ratio</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Calcium</li>\r\n<li>Phosphorus</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Sodium</li>\r\n<li>Potassium</li>\r\n<li>chloride</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Lipid Profile Tests <span className="totaltests">(9 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Cholesterol-Total, Serum</li>\r\n<li>HDL Cholesterol Direct</li>\r\n<li>LDL Cholesterol -Direct</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Triglycerides, Serum</li>\r\n<li>Non - HDL Cholesterol, Serum</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>VLDL</li>\r\n<li>LDL/HDL RATIO</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>CHOL/HDL RATIO</li>\r\n<li>HDL / LDL Cholesterol Ratio</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Thyroid Tests <span className="totaltests">(3 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>T3, Total Tri Iodothyronine</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>T4, Total Thyroxine</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>TSH Ultra - sensitive</li>\r\n\r\n</ul>\r\n</div>\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>HbA1c <span className="totaltests">(2 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Glycated Hemoglobin</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Average blood glucose</li>\r\n\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n\r\n<div className="firstList">\r\n<h2>Blood Sugar Fasting <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Vitamin B12 <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Vitamin D Total-25 Hydroxy <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>IgE Total (Allery) <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>RA Test Rheumatoid Arthritis Factor <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>CRP (C Reactive Protein) Quantitative <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>HsCRP High Sensitivity CRP <span className="totaltests">(1 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n\r\n</div>\r\n</div>\r\n\r\n<div className="firstList">\r\n<h2>Iron Studies <span className="totaltests">(4 Tests)</span>\r\n</h2><div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>Iron, Serum</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Uibc</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>TIBC</li>\r\n\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Transferrin Saturation</li>\r\n\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n\r\n\r\n<div className="firstList">\r\n<h2>Urine Routine & Microscopy<span className="totaltests">(21 Tests)</span></h2>\r\n<div className="parameterListDiv">\r\n<div className="parameterList">\r\n<ul>\r\n<li>pH Urine</li>\r\n<li>Specific gravity</li>\r\n<li>Bacteria</li>\r\n<li>Urobilinogen</li>\r\n<li>Deposit</li>\r\n<li>Leucocyte Esterase</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Transparency</li>\r\n<li>Albumin</li>\r\n<li>Sugar</li>\r\n<li>Blood</li>\r\n<li>Urine ketones</li>\r\n<li>Yeast Cells</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Colour</li>\r\n<li>Red blood cells</li>\r\n<li>Pus cells (Leukocytes)</li>\r\n<li>Nitrate</li>\r\n<li>Amorphous Deposits</li>\r\n</ul>\r\n</div>\r\n<div className="parameterList">\r\n<ul>\r\n<li>Epithelial cells</li>\r\n<li>Crystals</li>\r\n<li>Cast</li>\r\n<li>Volume</li>',
    faq: "",
    recommended_gender: null,
    recommended_age: "15-55",
    is_premium: false,
    package_city_prices: null,
    discount: 66.67,
    package_price: 5999,
    offer_price: 1999,
    is_addon: false,
    meta_title: "Advance Plus Full Body Checkup in Delhi @ Rs. 1999 Only",
    meta_description:
      "Redcliffe Labs is offering advance plus full body checkup that can help you to live a healthy life in this toxic world.",
    is_active: true,
    code: "pl14",
    og_tag:
      '{ "title" :"Advance Plus Full Body Checkup in Delhi @ Rs. 1999 Only", "site" : "Redcliffe Labs", "url" :"https://redcliffelabs.com/advance-plus-full-body-checkup-delhi", "description" :"Redcliffe Labs is offering advance plus full body checkup that can help you to live a healthy life in this toxic world." , "image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg","robots":"noindex"}',
    twitter_card:
      '{"card" : "summary" , "site" : "Redcliffe Labs" , "title" :"Advance Plus Full Body Checkup in Delhi @ Rs. 1999 Only", "description" :"Redcliffe Labs is offering advance plus full body checkup that can help you to live a healthy life in this toxic world.", "image" : "https://redcliffelabs.com/OG-Twitter-Card.jpg" }',
    addon_price: null,
    display_name: "Noida",
    specimen_instructions: null,
    package_center_prices: null,
  },
];

const Brcapage = ({ match }) => {
  useEffect(() => {
    Scroll();
  }, []);
  // const packagename = match.params.packagename;

  const packageDetails = useSelector((state) => state.packageDetails);
  const { loading, packDetail, error } = packageDetails;

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: loadingNavCities } = navCity;

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  console.log(citySelect, "111111111");

  // const [cityonUrl, setCityOnUrl] = useState(JoinedCityName);

  const [Error, setError] = useState(false);
  const [bookNow, setBooknow] = useState(false);
  const [scrool, setScroll] = useState(0);
  const [DivSize, setDivSize] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const currentCity = useRef();

  useEffect(() => {
    setDivSize(false);
  }, [citySelect]);
  // let packUrl = packagename.split("-");
  // let packSlug = packUrl.join("-");

  // packSlug = packSlug.substring(0, packSlug.lastIndexOf("-"));

  // const NewArray = packUrl.pop().split("_");

  // console.log(
  //   packDetail?.package_city_prices,
  //   "jshdf jhdshjf ",
  //   packDetail,
  //   "asjkdksaj ksjads ksjahkksad kjsdh k"
  // );

  // let firstName =
  //   NewArray[0].substring(0, 1).toUpperCase() + NewArray[0].substring(1);
  // var JoinedCityName = firstName;
  // if (NewArray.length > 1) {
  //   let secondName =
  //     NewArray[1].substring(0, 1).toUpperCase() + NewArray[1].substring(1);
  //   JoinedCityName = firstName + "_" + secondName;
  // }

  // useEffect(() => {
  //   Scroll();
  //   currentCity.current = citySelect;
  // }, [packagename]);

  useEffect(() => {
    dispatch({
      type: GET_PACKAGE_DETAILS_RESET,
    });
    // dispatch(setCity('Noida'));
    dispatch(getPackageDetails("smart-full-body-checkup", ""));
  }, [match]);

  // useEffect(() => {
  //   if (currentCity.current !== citySelect) {
  //     const LowerCase = citySelect?.toLowerCase();
  //     // setCityOnUrl(citySelect);
  //     const citySelectedNow = LowerCase.replace(" ", "-");
  //     history.push(`/${packSlug}-${citySelectedNow}`);
  //   }
  // }, [citySelected.citySelect]);

  useEffect(() => {
    const screenSize = window.screen.width;
    // console.log(screenSize);
    if (screenSize < 780) {
      setBooknow(true);
    } else {
      setBooknow(false);
    }
  }, []);

  const handelScroll = () => {
    window.addEventListener("scroll", function() {
      setScroll(window.scrollY);
    });
  };

  useEffect(() => {
    handelScroll();

    // setCityOnUrl('Noida');
  }, []);

  // useEffect(() => {
  //   Axios.get(`${Prefix.api}/core/displaycities/`)
  //     .then((response) => {
  //       const cityxx = packagename.split("-").pop();
  //       const result = response.data.cities.filter((word) => {
  //         return word?.toLowerCase() == cityxx;
  //       });
  //       if (result.length == 1) {
  //         setError(false);
  //       } else {
  //         setError(true);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [citySelected]);

  // if (packageDetails && packageDetails?.packDetail) {
  //   try {
  //     if (
  //       packDetail.package_city_metainfo &&
  //       packDetail.package_city_metainfo?.og_tag !== ""
  //     ) {
  //       var Og = JSON.parse(packDetail.package_city_metainfo.og_tag);
  //     } else {
  //       var Og = JSON.parse(packDetail.og_tag);
  //     }
  //   } catch (error) {}
  // }

  // if (packageDetails && packageDetails?.packDetail) {
  //   try {
  //     if (
  //       packDetail.package_city_metainfo &&
  //       packDetail.package_city_metainfo?.twitter_card !== ""
  //     ) {
  //       var twCard = JSON.parse(packDetail.package_city_metainfo.twitter_card);
  //     } else {
  //       var twCard = JSON.parse(packDetail.twitter_card);
  //       console.log(twCard, "package not city type");
  //     }
  //   } catch (error) {
  //     console.log(error, "Twitter Error");
  //   }
  // }

  //IF CONDITION FOR META INFODESCRIPTON
  if (packageDetails && packageDetails?.packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.meta_description !== ""
      ) {
        var metaDescrip = packDetail.package_city_metainfo.meta_description;
        console.log(metaDescrip, "from meta object data");
      } else {
        var metaDescrip = packDetail.meta_description;
        console.log(metaDescrip, "from default object");
      }
    } catch (error) {
      console.log(error, "error from metas");
    }
  }
  //IF CONDITION FOR META TITLE
  if (packageDetails && packageDetails?.packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.faq !== ""
      ) {
        var faqData = JSON.parse(packDetail.package_city_metainfo.faq);
        console.log(faqData, " faq from meta object data");
      } else if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.faq == ""
      ) {
        var faqData = packDetail.faq;
        console.log(faqData, "from default object");
      } else {
        var faqData = "";
      }
    } catch (error) {
      console.log(error, "error from metas");
    }
  }

  // const json = '{"result":{"key" : "one"}, "count":42}';
  // const obj = JSON.parse(json);
  // console.log("packdetail data" , obj);

  // //IF CONDITION FOR META description
  // if (packageDetails && packageDetails?.packDetail) {
  //     var content = packDetail.package_city_metainfo?.content;
  //     console.log("content ", JSON.parse(content));
  // }
  //for OURPAKAGE CARASOEL
  if (packageDetails && packageDetails?.packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.content !== ""
      ) {
        var desc = packDetail.package_city_metainfo.content;

        // console.log(desc, "from meta object data desc");
      } else {
        var desc = "empty";
      }
    } catch (error) {
      console.log(error, "error from desc");
    }

    var recommndedPackage = packDetail.related_packages;
  }

  //for FAQ DATA
  if (packageDetails && packageDetails?.packDetail) {
    // try {
    //   if (
    //     packDetail.package_city_metainfo &&
    //     packDetail.package_city_metainfo?.faq !== ""
    //   ) {
    //     var faqData = JSON.parse(packDetail.package_city_metainfo.faq);

    //     console.log(faqData, "from meta object data faq");
    //   } else {
    //     var faqData = packDetail.faq;
    //   }
    // } catch (error) {
    //   console.log(error, "error from desc");
    // }

    var recommndedPackage = packDetail.related_packages;
  }

  //for SCRATCH DATA
  if (packageDetails && packageDetails?.packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.scratch_code !== ""
      ) {
        var scratch_codeData = packDetail.package_city_metainfo.scratch_code;

        console.log(scratch_codeData, "from meta object data scratch_code");
      } else {
        var scratch_codeData = false;
      }
    } catch (error) {
      console.log(error, "error from scratch_code");
    }

    var recommndedPackage = packDetail.related_packages;
  }
  //{"list" : [1,2,3,4,5], ""faq Answer3""}
  // const array =  '[{"question":"faq question 1", "answer" : "faq Answer"},{"question":"faq question 2", "answer" : "faq Answer 2"},{"question":"faq question 2", "answer" : {"faq" : "anser 3" ,"list":[1,2,3]}}]';
  // console.log("parse array" ,   JSON.parse(array))

  return (
    <React.Fragment>
      {/* {packageDetails?.packDetail?.meta_title &&
        packageDetails?.packDetail?.og_tag &&
        Og &&
        twCard && (
          <Meta
            title={
              packDetail.package_city_metainfo
                ? packDetail.package_city_metainfo.meta_title
                : packDetail.meta_title?.replace("Delhi", `${cityonUrl}`)
            }
            description={
              packDetail.package_city_metainfo
                ? packDetail.package_city_metainfo.meta_description
                : packDetail.meta_description?.replace("Delhi", `${cityonUrl}`)
            }
            keywords={
              packDetail.package_city_metainfo
                ? packDetail.package_city_metainfo.meta_keyword
                : packDetail.meta_keyword
            }
          >
            <meta property="robots" content={Og.robots ? Og.robots : ""} />
            <meta
              property="og:title"
              content={Og?.title?.replace("Delhi", `${cityonUrl}`)}
            />
            <meta property="og:site_name" content={Og.site} />
            <meta
              property="og:url"
              content={Og?.url?.replace("delhi", `${cityonUrl?.toLowerCase()}`)}
            />
            <meta property="og:description" content={Og?.description} />
            <meta property="og:type" content={Og?.type} />
            <meta property="og:image" content={Og?.image} />
            {scratch_codeData ? (
              <script type="application/ld+json">{scratch_codeData}</script>
            ) : null}
            <meta name="twitter:card" content={twCard ? twCard.card : ""} />
            <meta name="twitter:site" content={twCard ? twCard.site : ""} />
            <meta
              name="twitter:title"
              content={
                twCard ? twCard.title?.replace("Delhi", `${cityonUrl}`) : ""
              }
            />
            <meta
              name="twitter:description"
              content={
                twCard
                  ? twCard.description?.replace("Delhi", `${cityonUrl}`)
                  : ""
              }
            />
            <meta name="twitter:image" content={twCard ? twCard.image : ""} />
          </Meta>
        )} */}
      <div>
        {/***Book Now bar below */}
        {/* {scrool === 0 ? (
          <>
            <TopNav />
            <Header />
          </>
        ) : bookNow && packDetail ? (
          <BookNow packDetail={packDetail} />
        ) : (
          <>
            <TopNav />
            <Header />
          </>
        )} */}
        {/* <TopNav /> */}
        <NewHeader />
        {loading ? (
          <Loader />
        ) : error || Error ? (
          <React.Fragment>
            <>
              <ErrorPage />
              <ScrolltoTop />
              <Footer />
            </>
          </React.Fragment>
        ) : (
          <div>
            <div className="lpBackground packBgMobile">
              <div className="imgProduct">
                <img src={MObileBG}></img>

                {packDetail && packDetail.name ? (
                  <h1 className="mainTagHeadingMobilePLandetail">
                    {packDetail.name}
                  </h1>
                ) : null}
              </div>
              <div className="planDiv">
                <div className="lpForm">
                  <div className="Report__Params">
                    <div className="Report__Test bg__blue">
                      <span>
                        {packDetail && packDetail.parameter
                          ? packDetail.parameter
                          : null}
                      </span>
                      {packDetail.parameter > 1 ? "Tests" : "Test"}
                    </div>
                    <div className="Report__rightSide">
                      <div className="Report__Mrp oldPrice">
                        <span>MRP</span>
                        <span style={{ textDecoration: "line-through" }}>
                          {" "}
                          &#8377;{" "}
                          {packDetail?.package_city_prices
                            ? packDetail?.package_city_prices?.package_price
                            : packDetail?.package_price}
                        </span>
                      </div>

                      <div className="Report__offerPrice">
                        <span>Offer Price</span>
                        &#8377;{" "}
                        {packDetail?.package_city_prices
                          ? packDetail?.package_city_prices.offer_price
                          : packDetail.offer_price}
                      </div>
                    </div>
                  </div>
                  <LpForm
                    butname={"SUBMIT"}
                    formId={"LpTop"}
                    position={"Top"}
                  />
                </div>
                <div className="planBookingDetail">
                  <div>
                    {packDetail && packDetail.name ? (
                      <h1 className="mainTagHeading">{packDetail.name}</h1>
                    ) : null}
                  </div>

                  <div className="plan_Parameters">
                    <h5>Test Parameters</h5>

                    <p className="parameterFont">
                      Now with{" "}
                      {packDetail && packDetail.parameter
                        ? packDetail.parameter
                        : null}{" "}
                      test
                    </p>

                    {/**description */}

                    <p className="paraDesc">
                      {packDetail && packDetail.description
                        ? packDetail.description
                        : null}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="formDivchildren planDetailMobileForm">
              <div className="lpForm">
                <div className="Report__Params">
                  <div className="Report__Test bg__blue">
                    <span>
                      {packDetail && packDetail.parameter
                        ? packDetail.parameter
                        : null}
                    </span>
                    {packDetail && packDetail.parameter > 1 ? "Tests" : "Test"}
                  </div>
                  <div className="Report__rightSide">
                    <div className="Report__Mrp oldPrice">
                      <span>MRP</span>
                      <span style={{ textDecoration: "line-through" }}>
                        {" "}
                        &#8377;{" "}
                        {packDetail && packDetail.package_price
                          ? packDetail.package_price
                          : null}
                      </span>
                    </div>

                    <div className="Report__offerPrice">
                      <span>Offer Price</span>
                      &#8377;{" "}
                      {packDetail && packDetail.offer_price
                        ? packDetail.offer_price
                        : null}
                    </div>
                  </div>
                </div>
                <LpForm butname={"SUBMIT"} formId={"LpTop"} position={"Top"} />
              </div>
            </div>

            <div className="lpParameters">
              <h5>Test Parameters</h5>

              <p className="parameterFont">
                Now with{" "}
                {packDetail && packDetail.parameter
                  ? packDetail.parameter
                  : null}{" "}
                tests which includes
              </p>

              {/**description */}

              <p className="paraDesc">
                {packDetail && packDetail.description
                  ? packDetail.description
                  : null}
              </p>
            </div>

            {packDetail &&
              packDetail.fasting_time &&
              packDetail.recommended_age &&
              packDetail.tat_time && (
                <div className="newCards">
                  <div className="lpDivRow">
                    {packDetail.tat_time ? (
                      <div className="lpcards">
                        <div className="card__imglp">
                          <img src={folder} alt={folder} />
                        </div>
                        <div className="card__contentlp">
                          <span className="mainHeading">Get Reports in</span>
                          <span className="redHeading">
                            {packDetail.tat_time}
                          </span>
                        </div>
                      </div>
                    ) : null}
                    {packDetail && packDetail.fasting_time ? (
                      <div className="lpcards">
                        <div className="card__imglp">
                          <img src={fasting} alt={fasting} />
                        </div>
                        <div className="card__contentlp">
                          <span className="mainHeading">Fasting Required</span>
                          <span className="redHeading">
                            {packDetail.fasting_time}
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {/* <div className="lpcards">
              <div className="card__imglp">
                <img src={WhyChooseUslogo3} alt={WhyChooseUslogo3} />
              </div>
              <div className="card__contentlp">
                <span className="mainHeading">Sample Collection</span>
                <span className="redHeading">Urine, Blood, Swab</span>
              </div>
            </div> */}
                    {packDetail && packDetail.recommended_age ? (
                      <div className="lpcards">
                        <div className="card__imglp">
                          <img src={watch} alt={watch} />
                        </div>
                        <div className="card__contentlp">
                          <span className="mainHeading">Age Group</span>
                          <span className="redHeading">
                            {packDetail.recommended_age} yrs
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}

            {related_packages && related_packages.length > 0 ? (
              <div className="parentDiv ">
                <div className="childDiv container">
                  <div className="HeaderDiv">
                    <div className="divHeading">
                      <h2>Best health check-up packages</h2>
                    </div>

                    <a href={`${process.env.RAZZLE_APP_BASE_URL}/health-checkup-packages`}>View All</a>
                  </div>

                  <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={false}
                    autoPlaySpeed={2500}
                    transitionDuration={200}
                    deviceType={"tablet"}
                  >
                    {loading ? (
                      <Loader />
                    ) : (
                      related_packages.map((card) => (
                        <div
                          className={
                            card.is_premium
                              ? "Package__card bgPremium "
                              : "Package__card bgOrdinary "
                          }
                          key={card.id}
                        >
                          <div className="packageTop">
                            <span
                              className={
                                card.is_premium ? "bgGreen" : "bgOrange"
                              }
                            >
                              {card.is_premium
                                ? "Most Popular Plan"
                                : "Heath Check-up"}
                            </span>{" "}
                          </div>

                          <div className="packageBottom">
                            <div className="Package__cardTitle">
                              <span
                                className={
                                  card.is_premium ? "textWhite" : "textBlue "
                                }
                              >
                                <Link
                                  className={
                                    card.is_premium ? "textWhite" : "textBlue "
                                  }
                                  to={`/${card.slug}`}
                                >
                                  {card.name}
                                </Link>
                              </span>
                            </div>
                            <div className="Package__cardList">
                              <ul>
                                <li>
                                  {" "}
                                  <FaCheck /> Total no.of Tests -{" "}
                                  {card.parameter}{" "}
                                </li>
                                <li>
                                  {" "}
                                  <FaCheck /> Quick Turn Around Time{" "}
                                </li>
                                <li>
                                  {" "}
                                  <FaCheck /> Reporting as per NABL ISO
                                  guidelines{" "}
                                </li>
                              </ul>
                            </div>
                            <div className="Package__cardPrice">
                              <span
                                className={
                                  card.is_premium ? "text_Color" : "card__Mrp"
                                }
                              >
                                {" "}
                                MRP : &#8377; {card.package_price}
                              </span>
                              <span
                                className={
                                  card.is_premium
                                    ? " card__offerPrice  "
                                    : "   card__offerPrice textGrey"
                                }
                              >
                                {" "}
                                Offer Price : &#8377; {card.offer_price}
                              </span>
                            </div>

                            <Link
                              className="Package__BookButton"
                              to={`/${card.slug}`}
                            >
                              <span>Book Now</span>
                            </Link>
                          </div>
                        </div>
                      ))
                    )}
                  </Carousel>
                </div>
              </div>
            ) : (
              ""
            )}

            {/**Table */}
            {/* <div className="WhyChooseUs">
              <div className="table_NEW">
               
                <div className="table  ">
                  <div className="parentRow_div">
                    <div>
                      <h2>Mode Of Sample</h2>
                      <p>Blood Sample (3-5 ml)</p>
                    </div>

                    <div className="Preparation">
                      <h2>Preparation for test</h2>
                      <p>Not required</p>
                    </div>

                    <div>
                      <h2>Report Availability</h2>
                      <p>20 to 25 working days</p>
                    </div>
                  </div>

                  <div className="secondDiv  ">
                    <h2>Who should consider getting tested ?</h2>
                  </div>
                  <div className="newTableList">
                    <ul>
                      <li>
                        Someone that has a family history or a close blood
                        relative is diagnosed with Breast Malignancy at the age
                        of 50 years or earlier.
                      </li>
                      <li>
                        {" "}
                        History of Cancer in one or more Reproductive organs
                        like Ovarian Cancer or Cervical Cancers.
                      </li>

                      <li>Any male/female with the cancer of chest/breast.</li>
                      <li>Case of triple-negative breast cancer. </li>
                      <li>
                        Prior cases of BRCA1 or BRCA2 mutation in the family.{" "}
                      </li>
                      <li>
                        Females above the age of 30 should consider screening.{" "}
                      </li>
                    </ul>
                  </div>
                  <div className="testInter">
                    <b>Test interpretation :</b>
                    <p>
                      **The genetic counsellor will help in the report
                      interpretation to the concerned person.
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
            {/* wHY CHOOSE US */}

            <div className="WhyChooseUs">
              <div className="whyUscontainer">
                <h2>Why Choose Us?</h2>
                <div className="Four_div_box">
                  <div className="For_Image_And_text">
                    <div className="WhyChooseUslogo">
                      <img src={WhyChooseUslogo1} alt="Assured Safety" />
                    </div>
                    <p className="whyChooseUspara"> Assured Safety</p>
                  </div>
                  <div className="For_Image_And_text">
                    <div className="WhyChooseUslogo">
                      <img src={WhyChooseUslogo2} alt="Certified Labs" />
                    </div>
                    <p className="whyChooseUspara"> Certified Labs</p>
                  </div>
                  <div className="For_Image_And_text">
                    <div className="WhyChooseUslogo">
                      <img src={WhyChooseUslogo3} alt="Free Sample Pick-Up" />
                    </div>
                    <p className="whyChooseUspara">Free Sample Pick-Up</p>
                  </div>
                  <div className="For_Image_And_text">
                    <div className="WhyChooseUslogo">
                      <img src={WhyChooseUslogo4} alt="Accurate Reports" />
                    </div>
                    <p className="whyChooseUspara"> Accurate Reports</p>
                  </div>
                </div>
                <div className="forBackgroundcolor">{/* Blank */}</div>
              </div>
            </div>
            {/**SAFETY STEPS */}
            <div className="safetyDiv">
              <h2>5 Steps to Safety</h2>
              <p>
                {" "}
                <span>10+ Lacs</span> Total orders delivered
              </p>
              <div className="safetySteps">
                {stepsData.map((values, index) => (
                  <div className="safety__card" key={values.id}>
                    <div className="safety_cardIMG">
                      <img src={values.img} alt="image"></img>
                    </div>
                    <div className="steps">
                      <span>{values.id}</span>
                    </div>
                    <div className="safetyStep">
                      <span>{values.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/***APPOINTMENT DIV */}
            <div className="appointMentLpDiv">
              <Apointment img={stars} />

              <div className="mobileApointment">
                <h5>Make Appointment</h5>
                <p>Start Your Journey With Healthy India Ki Trusted Lab.</p>
              </div>
              <LpForm
                butname={"Book Your Test"}
                position={"bottom"}
                title={"Book Your Test"}
              />
            </div>
            {/* *ONE COMPONENT */}
            {desc == "empty" ? null : (
              <div
                className={DivSize ? "expanTrue readMoreDiv" : "readMoreDiv"}
              >
                <span
                  className="read_more"
                  onClick={() => setDivSize(!DivSize)}
                >
                  {DivSize ? "Read Less" : "Read More"}
                </span>
                {desc && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${desc}`,
                    }}
                  ></div>
                )}
              </div>
            )}

            {/* <Onecomponent title={metaPacTitle} content={metaDescrip} />/*}
            <TestCr /> 

            {/* TE S T I M O N I A L */}
            {faqData == "" ? null : loading ? (
              <Loader />
            ) : (
              <TestCr faq={faqData} />
            )}

            <Content
              title="Testimonials"
              Ispackage={false}
              isTestimonial={true}
            />
            <Featured />

            <ScrolltoTop />
            <Footer />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default {
  component: Brcapage,
};
